import { ContentWrapper, User } from '../../components';

export const UserPage = () => {
  return (
    <ContentWrapper>
      <User />
    </ContentWrapper>
  );
};
